import React from "react";

export const Span = ({ children, ...props }) => <span {...props}>{children}</span>;

export const Br = () => <br />;
